module.exports = __webpack_public_path__ + "img/thumbnail_AlpineIbex_m_normal.94e2b7e9.png";